import Vue from 'vue'
import Router from 'vue-router'
import * as types from '../store/mutationTypes'
import { setDocumentTitle } from '../plugin/setTitle/setDocumentTitle'
import { isForward } from './pageTransition'
// 路由数据
import routes from '../routerConfig'
Vue.use(Router)

const router = new Router({
  routes
})

export default router

/**
 * 切换动画名称
 */
const SLIDE_LEFT = 'slide-left'
const SLIDE_RIGHT = 'slide-right'

router.beforeEach(async (to, from, next) => {
  if (router.app.$store) {
    // 如果不需要过渡动画，直接走next
    if (router.app.$store.state.appShell.needPageTransition) {
      // 判断当前是前进还是后退，添加不同的动画效果
      let pageTransitionName = isForward(to, from) ? SLIDE_LEFT : SLIDE_RIGHT
      router.app.$store.commit(`appShell/${types.SET_PAGE_TRANSITION_NAME}`, { pageTransitionName })
    }
  }
  if (to.name) {
    setDocumentTitle(to.name)
  }
  if (process.env.NODE_ENV === 'development') {
    next()
    return
  }
  let openId = getQueryString(location.href, 'openId') || '' // 如果链接有openId就获取并存起来
  let mailNo = getQueryString(location.href, 'mailNo') || ''
  if (openId) {
    sessionStorage.setItem('OPENID', openId)
    if (to.path === '/query') {
      window.location.href = `${process.env.VUE_APP_URL}/priorityMail/index.html#/query`
    } else {
      window.location.href = `${process.env.VUE_APP_URL}/priorityMail/index.html#/queryDetail/${mailNo}`
    }
    location.reload()
    return
  }
  if (!openId && !sessionStorage.getItem('OPENID')) {
    if (to.path === '/query' || to.path === `/queryDetail/${to.params.mailNo}`) {
      next('/noVisit')
    }
    next()
    return
  }
  next()

  // console.log('2')
  // const mailNo = getQueryString(location.href, 'mailNo') || ''
  // if (to.path !== '/query' && mailNo) {
  //   if (process.env.NODE_ENV === 'test') {
  //     window.location.href = `https://wx.emspost.com.cn/weixin/newmail-api/priorityMail/index.html#/queryDetail/${mailNo}`
  //   } else {
  //     window.location.href = `https://wx.gdems.com/priority-mail/priorityMail/index.html#/queryDetail/${mailNo}`
  //   }
  //   console.log(location.href)
  //   location.reload()
  //   return
  // }
  // next()
})
// async function getIsFollow (openid) {
//   let params = {
//     openId: openid
//   }
//   const { data } = await fetch.post({
//     url: '/SubscribeOrnot',
//     data: params,
//     headers: {
//       'USER-SIGN': setUserSign('/SubscribeOrnot', params)
//     }
//   })
//   console.log('是否关注  ' + data.info)
//   return data.info
// }
function getQueryString (url, query) {
  if (!url || !query) {
    return false
  }

  const reg = /[?&]([^=&#]+)=([^?&#]*)/g
  const queryString = url.match(reg) || []
  // eslint-disable-next-line no-unused-vars
  for (let item of queryString) {
    const queryArray = item && item.substr(1).split('=')
    const resultKey = queryArray[0]
    const resultValue = queryArray[1]
    if (resultKey === query && resultValue) {
      return resultValue
    }
  }
}
